import { ArchiveNodeOption } from "models/ArchiveNodeOption";
import { useGlobalContext } from "app/store/GlobalContext";

import "./UserServiceView.scss";

type Props = {
  userId: string;
  fpConfig: any;
  unique: string;
  isInternal: boolean;
  parent: ArchiveNodeOption;
  onSetService: (service: ArchiveNodeOption, value: boolean) => void;
  onSetFpService: (customerChoice: string) => void;
};

export default function UserServiceView({
  userId,
  fpConfig,
  unique,
  isInternal,
  parent,
  onSetService,
  onSetFpService,
}: Props) {
  const { setEditingState } = useGlobalContext();

  const handleOnChange = (service: ArchiveNodeOption, value: boolean) => {
    setEditingState({ isEditing: true, location: "customer-settings" });
    onSetService(service, value);
  };

  const handleOnFpChange = (customerChoice: string) => {
    onSetFpService(customerChoice);
  };

  const renderView = () => {
    return (
      <ul>
        {parent.nodes.map((node) => {
          if (node.enabled !== true) {
            return <li key={node.id} />;
          }
          return (
            <li key={node.id}>
              <div className="foldersWrapper">
                <input
                  id={node.id + unique}
                  type="checkbox"
                  name={unique}
                  checked={node.active || node.locked}
                  disabled={node.locked}
                  onChange={(e) => {
                    handleOnChange(node, e.target.checked);
                  }}
                />
                <label htmlFor={node.id + unique} className="d-inline">
                  {node.name}
                </label>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  const renderFpOff = () => {
    if (fpConfig) {
      const checked =
        fpConfig.customerChoice === "Off" ||
        fpConfig.userIds.filter((id: string) => id === userId).length === 0;
      return (
        <li key={parent.id}>
          <div>
            <input
              id={"fp.none" + unique}
              type="radio"
              name={"fp_" + unique}
              checked={checked}
              onChange={() => handleOnFpChange("Off")}
            />
            <label htmlFor={"fp.none" + unique}>Av</label>
          </div>
        </li>
      );
    }
  };

  const renderFpSelect = () => {
    if (fpConfig) {
      const checked =
        fpConfig.userIds.filter((id: string) => id === userId).length > 0;
      if (fpConfig.customerChoice === "Month") {
        return (
          <li key={"fp.month" + unique}>
            <div>
              <input
                id={"fp.month" + unique}
                type="radio"
                name={"fp_" + unique}
                checked={checked}
                onChange={() => handleOnFpChange("Month")}
              />
              <label htmlFor={"fp.month" + unique}>Månadsvy</label>
            </div>
          </li>
        );
      } else if (fpConfig.customerChoice === "VirtualFarmer") {
        return (
          <li key={"fp.month.db" + unique}>
            <div>
              <input
                id={"fp.month.db" + unique}
                type="radio"
                name={"fp_" + unique}
                checked={checked}
                onChange={() => onSetFpService("VirtualFarmer")}
              />
              <label htmlFor={"fp.month.db" + unique}>
                Månadsvy Digital Bonde
              </label>
            </div>
          </li>
        );
      } else if (fpConfig.customerChoice === "Year") {
        return (
          <li key={"fp.year" + unique}>
            <div>
              <input
                id={"fp.year" + unique}
                type="radio"
                name={"fp_" + unique}
                checked={checked}
                onChange={() => handleOnFpChange("Year")}
              />
              <label htmlFor={"fp.year" + unique}>
                Årsvy Digital Skogsägare
              </label>
            </div>
          </li>
        );
      }
    }
  };

  const renderFpView = () => {
    return (
      <ul>
        {renderFpOff()}
        {renderFpSelect()}
      </ul>
    );
  };

  const description = parent.description && (
    <div className="description">{parent.description}</div>
  );

  const view = parent.id === "fp" ? renderFpView() : renderView();

  return (
    <div className="userServiceView">
      <div className="title">{parent.name}</div>
      {description}
      {view}
    </div>
  );
}
